import {Component, Input} from '@angular/core';
import {AddProduct, Product} from '@uofu-uss-aux/software-catalog-ng-core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  standalone: true,
  imports: [
    RouterLink
  ]
})
export class SearchResultComponent extends AddProduct(Object) {

  @Input()
  product: Product;

}
